function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/inputtext/inputtextview
 */
import View from '../view';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import '../../theme/components/inputtext/inputtext.css';
/**
 * The text input view class.
 *
 * @extends module:ui/view~View
 */

var InputTextView = /*#__PURE__*/function (_View) {
  _inherits(InputTextView, _View);

  var _super = _createSuper(InputTextView);

  /**
   * @inheritDoc
   */
  function InputTextView(locale) {
    var _this;

    _classCallCheck(this, InputTextView);

    _this = _super.call(this, locale);
    /**
     * The value of the input.
     *
     * @observable
     * @member {String} #value
     */

    _this.set('value');
    /**
     * The `id` attribute of the input (i.e. to pair with a `<label>` element).
     *
     * @observable
     * @member {String} #id
     */


    _this.set('id');
    /**
     * The `placeholder` attribute of the input.
     *
     * @observable
     * @member {String} #placeholder
     */


    _this.set('placeholder');
    /**
     * Controls whether the input view is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     */


    _this.set('isReadOnly', false);
    /**
     * Set to `true` when the field has some error. Usually controlled via
     * {@link module:ui/labeledinput/labeledinputview~LabeledInputView#errorText}.
     *
     * @observable
     * @member {Boolean} #hasError
     */


    _this.set('hasError', false);
    /**
     * The `id` of the element describing this field, e.g. when it has
     * some error, it helps screen readers read the error text.
     *
     * @observable
     * @member {Boolean} #ariaDescribedById
     */


    _this.set('ariaDescribedById');
    /**
     * Stores information about the editor UI focus and propagates it so various plugins and components
     * are unified as a focus group.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker} #focusTracker
     */


    _this.focusTracker = new FocusTracker();
    /**
     * An observable flag set to `true` when the input is currently focused by the user.
     * Set to `false` otherwise.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isFocused
     * @default false
     */

    _this.bind('isFocused').to(_this.focusTracker);
    /**
     * An observable flag set to `true` when the input contains no text, i.e.
     * when {@link #value} is `''`, `null`, or `false`.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isEmpty
     * @default true
     */


    _this.set('isEmpty', true);

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'input',
      attributes: {
        type: 'text',
        class: ['ck', 'ck-input', 'ck-input-text', bind.if('isFocused', 'ck-input_focused'), bind.if('isEmpty', 'ck-input-text_empty'), bind.if('hasError', 'ck-error')],
        id: bind.to('id'),
        placeholder: bind.to('placeholder'),
        readonly: bind.to('isReadOnly'),
        'aria-invalid': bind.if('hasError', true),
        'aria-describedby': bind.to('ariaDescribedById')
      },
      on: {
        input: bind.to('input'),
        change: bind.to(_this._updateIsEmpty.bind(_assertThisInitialized(_this)))
      }
    });
    /**
     * Fired when the user types in the input. Corresponds to the native
     * DOM `input` event.
     *
     * @event input
     */


    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InputTextView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(InputTextView.prototype), "render", this).call(this);

      this.focusTracker.add(this.element);

      this._setDomElementValue(this.value);

      this._updateIsEmpty(); // Bind `this.value` to the DOM element's value.
      // We cannot use `value` DOM attribute because removing it on Edge does not clear the DOM element's value property.


      this.on('change:value', function (evt, name, value) {
        _this2._setDomElementValue(value);

        _this2._updateIsEmpty();
      });
    }
    /**
     * Moves the focus to the input and selects the value.
     */

  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
    /**
     * Focuses the input.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
    /**
     * Updates the {@link #isEmpty} property value on demand.
     *
     * @private
     */

  }, {
    key: "_updateIsEmpty",
    value: function _updateIsEmpty() {
      this.isEmpty = isInputElementEmpty(this.element);
    }
    /**
     * Sets the `value` property of the {@link #element DOM element} on demand.
     *
     * @private
     */

  }, {
    key: "_setDomElementValue",
    value: function _setDomElementValue(value) {
      this.element.value = !value && value !== 0 ? '' : value;
    }
  }]);

  return InputTextView;
}(View);

export { InputTextView as default };

function isInputElementEmpty(domElement) {
  return !domElement.value;
}